import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { Oauth } from '../../modules/common/entities/user/oauth.entity';
import { OauthState, SharedApplicationState } from '../shared-state.interface';
import { oauthAdapter } from './oauth.reducer';

export const getOauthState: MemoizedSelector<
    object,
    OauthState,
    DefaultProjectorFn<OauthState>
> = createFeatureSelector<OauthState>('oauth');

const { selectAll } = oauthAdapter.getSelectors(getOauthState);
export { selectAll as selectAllOAuth };

const { selectEntities } = oauthAdapter.getSelectors(getOauthState);
export { selectEntities as selectOAuthEntities };

export const selectOAuthFeature: (state: SharedApplicationState) => OauthState = (state: SharedApplicationState) =>
    state.oauth;

export function getOauthStateById(
    id: string
): MemoizedSelector<object, Oauth | undefined, DefaultProjectorFn<Oauth | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<Oauth>) => entries[id]);
}

export const oauthSelector: MemoizedSelector<
    object,
    Dictionary<Oauth>,
    DefaultProjectorFn<Dictionary<Oauth>>
> = createSelector(selectEntities, (entries: Dictionary<Oauth>) => entries);
